module.exports = __webpack_public_path__ + "static/media/logov1.a1ecf508.jpg";